module.exports = __webpack_public_path__ + "static/img/new_15x5.aade820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_15x5.png
// module id = vDw6
// module chunks = 101